
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Dossier } from './dossier';
import { DossierService, DossierFilter } from './dossier.service';
import { DossierFilterDialogComponent } from './dossier-filter-dialog.component';
import { NotifierService, DialogService } from '../ui';

const FILTER_KEY = 'dossiers-archive.filter';

@Component({
  templateUrl: './archived-dossier-list.component.html',
})
export class ArchivedDossierListComponent implements OnInit {

  filter: DossierFilter;

  perPage = 10
  dossiersCount: number = 0
  dossiers: Dossier[]

  constructor(
    private dossierService: DossierService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.filter = new DossierFilter();

    // Fetch only archived dossiers
    this.filter.is_archived = true;

    // Load filter from localStorage
    if(window.localStorage) {
      try {
        let data = window.localStorage.getItem(FILTER_KEY);

        let filterData = JSON.parse(data);

        assign(this.filter, filterData);
      }
      catch(err) {
      }
    }
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.dossiers.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.dossierService
      .dossiers(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.dossiers = result.dossiers;
        }
        // Append
        else {
          this.dossiers = [...this.dossiers || [], ...result.dossiers];
        }

        this.dossiersCount = result.dossiersCount;
      });
    
    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, JSON.stringify(this.filter));
    }
  }

  showDossier(dossier: Dossier, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['dossiers', 'archive', dossier.id]);
    }
  }

  delete(dossier: Dossier) {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer ce dossier?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.dossierService
          .delete(dossier.id)
          .subscribe((id) => {
            this.notifier.success('Dossier supprimé avec succès');

            this.fetch(0, this.dossiers.length, true);

          }, (err) => {
            this.notifier.endProgress();
          });
      });

    return false;
  }

  unarchive(dossier: Dossier) {
    this.dialogService
      .confirm({
        title: 'Archivage',
        message: 'Voulez-vous restaurer ce dossier?',
        confirm_button_text: 'Restaurer',
        confirm_button_class: 'btn-primary'
      })
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.dossierService
          .unarchive(dossier.id)
          .subscribe((id) => {
            this.notifier.success('Dossier restauré avec succès');

            this.fetch(0, this.dossiers.length, true);

          }, (err) => {
            this.notifier.endProgress();
          });
      });

    return false;
  }

  applyFilter() {
    this.dialogService.show({
      component: DossierFilterDialogComponent,
      props: {

        filter: this.filter,

        onClose: () => {
          this.dialogService.hide();
        },

        onApply: (filter: DossierFilter) => {
          this.fetch(0, this.perPage, true);
        }
      }
    });
  }

  clearSearch() {
    this.filter.search = '';

    this.fetch(0, this.perPage, true);
  }
}
